import state from './moduleDistrictState.js'
import mutations from './moduleDistrictMutations.js'
import actions from './moduleDistrictActions.js'
import getters from './moduleDistrictGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
